import { render, staticRenderFns } from "./psichase.vue?vue&type=template&id=81154294&scoped=true&"
import script from "./psichase.vue?vue&type=script&lang=js&"
export * from "./psichase.vue?vue&type=script&lang=js&"
import style0 from "./psichase.vue?vue&type=style&index=0&id=81154294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81154294",
  null
  
)

export default component.exports